import { createAsyncThunk, AsyncThunk } from '@reduxjs/toolkit';
import { basicApiAsyncThunkCreator } from '../../services/apiAsyncThunkCreator';
import { ThunkAPI } from '../rootReducer';
import { SERVICES, HttpMethods } from '../../services/api';
import { showErrorMessage, showSuccessMessage } from '../notifications';

export interface IdentityProviderDTO {
  _id?: string;
  accountId: string;
  type: string;
  metadataUrl: string;
  metadataFile: string;
  clientId: string;
  clientSecret: string;
  issuer: string;
  attributeRequestMethod: string;
  authorizeScopes: string;
  authorizeUrl: string;
  tokenUrl: string;
  attributesUrl: string;
  jwksUri: string;
  useSsoOnly: boolean;
}

export const createIdentityProvider: AsyncThunk<void, IdentityProviderDTO, ThunkAPI> = createAsyncThunk(
  'createIdentityProvider',
  async (dto: IdentityProviderDTO, thunk) => {
    try {
      const response = await basicApiAsyncThunkCreator<void, IdentityProviderDTO>({
        endpoint: 'identity-providers',
        microservice: SERVICES.USERS_SERVICE,
        authenticated: true,
        method: HttpMethods.Post,
        contentType: 'application/json'
      })(dto, thunk);
      thunk.dispatch(showSuccessMessage('The SSO Provider has been created'));
      return response;
    } catch(err) {
      thunk.dispatch(showErrorMessage('An error occurred'));
      return thunk.rejectWithValue(err || 'An error occurred when creating the SSO Provider');
    }
  }
);

export const updateIdentityProvider: AsyncThunk<void, IdentityProviderDTO, ThunkAPI> = createAsyncThunk(
  'updateIdentityProvider',
  async (dto: IdentityProviderDTO, thunk) => {
    try {
      const response = await basicApiAsyncThunkCreator<void, IdentityProviderDTO>({
        endpoint: 'identity-providers',
        microservice: SERVICES.USERS_SERVICE,
        authenticated: true,
        method: HttpMethods.Put,
        contentType: 'application/json'
      })(dto, thunk);
      thunk.dispatch(showSuccessMessage('The SSO Provider has been updated'));
      return response;
    } catch(err) {
      thunk.dispatch(showErrorMessage('An error occurred'));
      return thunk.rejectWithValue(err || 'An error occurred when updating the SSO Provider');
    }
  }
);

export interface IDeleteIdentityProviderRequest {
  accountId: string;
}

export const deleteIdentityProvider: AsyncThunk<void, IDeleteIdentityProviderRequest, ThunkAPI> = createAsyncThunk(
  'deleteIdentityProvider',
  async (request: IDeleteIdentityProviderRequest, thunk) => {
    try {
      const response = await basicApiAsyncThunkCreator<void, IDeleteIdentityProviderRequest>({
        endpoint: 'identity-providers',
        microservice: SERVICES.USERS_SERVICE,
        authenticated: true,
        method: HttpMethods.Delete,
        contentType: 'application/json'
      })(request, thunk);
      thunk.dispatch(showSuccessMessage('The SSO Provider has been deleted'));
      return response;
    } catch(err) {
      thunk.dispatch(showErrorMessage('An error occurred'));
      return thunk.rejectWithValue(err || 'An error occurred when updating the SSO Provider');
    }
  }
);
